import { getEmpresaIdpk } from '@/features/login/util';
import { fetchApi } from '@/std/api/fetchApi';
import { ErroOrigem } from '../../painel-administrativo/erro/types';

export type InternoErroBody =
    | {
          type: 'REACT_ERROR';
          kind: 'caught' | 'recoverable' | 'uncaught';
          message: string;
          name: string | undefined;
          stack: string | undefined;
          component_stack: string | undefined;
          error_boundary: string | undefined;
      }
    | {
          type: 'SCHEMA';
          message: string;
      };

export function apiInternoErroPost(body: InternoErroBody) {
    const empresaIdpk = getEmpresaIdpk();

    return fetchApi({
        body: {
            APP_VERSION,
            empresa_idpk: empresaIdpk,
            url: window.location.href,
            ...body,
        },
        empresaIdpk: false,
        endpoint: 'Interno/Erro',
        method: 'post',
        params: {
            origem: ErroOrigem.Frontend,
        },
        schema: null,
        token: false,
    });
}
